import { useContext, useEffect, useState } from "react";
import { Select, MenuItem, Divider } from "@mui/material";
import { GenAiContext } from "@/client/context";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { accessTokenState } from "@/client/state";
import { IAccount } from "@/pages/Account";
import { companyNameState } from "@/client/state";

type Props = {
  value?: string | number | undefined;
  onChange?: (value: string) => void;
};

const CompanyDropdown = ({ value, onChange }: Props) => {
  const accessToken = useRecoilValue(accessTokenState);
  const apiClient = useContext(GenAiContext);
  const setCompanyName = useSetRecoilState(companyNameState);

  const [accountData, setAccountData] = useState<IAccount[]>([]);

  useEffect(() => {
    const getAccountData = async () => {
      try {
        const response = await apiClient.getAllAccountsNoPagination(
          accessToken
        );
        setAccountData(response?.data || []);
      } catch (err) {
        console.error("Failed to get account data.", err);
      }
    };

    getAccountData();
  }, [apiClient, accessToken]);

  const handleChange = (id: string, label: string) => {
    if (onChange) {
      onChange(id);
    }
    setCompanyName(label);
  };

  return (
    <Select
      value={value !== undefined ? String(value) : ""}
      displayEmpty
      size="small"
      sx={{ minWidth: 150, borderRadius: "25px" }}
      MenuProps={{
        PaperProps: {
          sx: {
            width: 300,
          },
        },
      }}
    >
      <MenuItem disabled value="">
        Select Company
      </MenuItem>
      <Divider sx={{ opacity: 0.3 }} />

      {Array.isArray(accountData) &&
        accountData.map((account) => (
          <MenuItem
            key={account.id}
            value={account.id}
            data-label={account.company_name}
            onClick={() =>
              handleChange(String(account.id), account.company_name)
            } // ✅ pass both
          >
            {account.company_name}
          </MenuItem>
        ))}
    </Select>
  );
};

export default CompanyDropdown;
